// Helper function to calculate GCD
const gcd = (a: number, b: number): number => {
  a = Math.abs(Math.round(a));
  b = Math.abs(Math.round(b));
  while (b) {
    const t = b;
    b = a % b;
    a = t;
  }
  return a;
};

// Helper function to simplify ratio
export const calculateRewardMultiplier = (a: number, b: number): string => {
  if (b === 0) return '0:0';

  // Scale the values to handle decimals properly (at least 2 decimal places)
  const precision = 100;
  const scaledA = Math.round(a * precision);
  const scaledB = Math.round(b * precision);

  const divisor = gcd(scaledA, scaledB);
  if (divisor === 0) return '0:0';

  return `${Math.round(scaledA / divisor)}:${Math.round(scaledB / divisor)}`;
};
